import { KRONOS_UNITS } from "../constants";
import { Timer } from "../entities";
import { kronosSecondsSplice } from "../helpers";

/**
 *
 * @returns {ReactElement} KronosTimerDuration page
 */
export function KronosTimerDuration({
  timer,
  splice,
  forDate,
  durationInSeconds,
  color = "#2196f3",
}: KronosTimerDurationType) {
  const s =
    splice ??
    timer?.splice(forDate) ??
    kronosSecondsSplice(durationInSeconds) ??
    [];
  return (
    <span>
      {s.map((s, i) => (
        <span key={i} style={{ color: s === "0" ? "#e0e0e0" : color }}>
          <b>{` ${s}`}</b>
          <span style={{ color: s === "0" ? "#e0e0e0" : color }}>
            {KRONOS_UNITS[i] ?? ""}
          </span>
        </span>
      ))}
    </span>
  );
}

type KronosTimerDurationType = {
  timer?: Timer;
  splice?: string[];
  durationInSeconds?: number;
  color?: string;
  forDate?: string;
};
